import { useFeatureFlagEnabled } from '@posthog/react';

export const LAND_RIGHTS_TITLE_ZIPS_VIA_S3_FLAG = 'land-rights-title-zips-via-s3';

/** Title reports and documents download through a signed S3 URL instead of an in-page blob. */
export function useLandRightsTitleZipsViaS3Enabled(): boolean {
  return useFeatureFlagEnabled(LAND_RIGHTS_TITLE_ZIPS_VIA_S3_FLAG) === true;
}
